<template>
    <div class="hired">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4 mt-4">
                <div class="text-left mt-3 ml-5 mb-4">
                    <a-icon class="mr-1" type="arrow-left" />
                    <span class="go-back" @click="goBack">Go Back</span>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-8">
                        <div class="mt-5">
                            <!-- <a-tabs defaultActiveKey="1">
                <a-tab-pane tab="Details" key="1"> -->
                            <div class="bg-light border add-rounded p-4 p-lg-5 mt-4">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-9">
                                        <div class="row pl-3">
                                            <div>
                                                <h5 class="font-weight-bolder text-left">
                                                    Customise Wordpress Login
                                                </h5>
                                            </div>
                                            <a-tooltip placement="topLeft">
                                                <template slot="title">
                                                    <span>
                                                        <a-icon
                                                            class="mr-2"
                                                            type="info-circle"
                                                            style="position:relative; bottom: 3px;font-size: 16px;"
                                                        />
                                                        click to copy
                                                    </span>
                                                </template>
                                                <span class="ml-2">
                                                    <div class="kova-id ml-3 text-white px-3" style="height: 20px">
                                                        ID: 23498
                                                    </div>
                                                </span>
                                            </a-tooltip>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-3">
                                        <div class="text-right font-weight-bolder">
                                            <font-awesome-icon icon="clock" class="mr-2" />Bidding closed
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <h5 class="text-left mt-3">Brief</h5>
                                        <p class="text-left">
                                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                            eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                            voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
                                            clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
                                            amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                                            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
                                            diam
                                        </p>
                                        <h5 class="text-left mt-3">Skill Required</h5>
                                        <div class="text-left d-flex flex-wrap">
                                            <span
                                                class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2"
                                                v-for="skill in skills"
                                                :key="skill"
                                            >
                                                {{ skill }}</span
                                            >
                                        </div>
                                        <h5 class="text-left mt-3">Budgets</h5>
                                        <div class="row pl-3">
                                            <div class="d-flex col-7">
                                                <div>
                                                    <h4 class="text-left font-weight-bolder">
                                                        $1,340 - $3,000 . x
                                                    </h4>
                                                </div>
                                                <div class="ml-3 mt-2 incr-font-2 font-italic mb-3 mt-0">
                                                    $20.00/hr
                                                </div>
                                            </div>
                                            <div class="col-5 text-left">
                                                <button class="btn-kovatek shadow py-2 px-4 btn-rounded ml-4 ml-md-5">
                                                    Apply
                                                </button>
                                                <!-- <button class="btn-kovatek shadow py-2 px-3 px-md-4 btn-rounded ml-4 ml-md-5 pl-md-4">Enter Project Board</button> -->
                                            </div>
                                        </div>
                                        <div class="mt-3">
                                            <p class="ant-color text-left" v-if="showmore" @click="showOtherDetails">
                                                View More Details<a-icon
                                                    class="ml-2"
                                                    type="double-right"
                                                    :rotate="90"
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="pt-3" v-if="otherDetails">
                                    <hr />
                                    <div class="row mt-2 text-left">
                                        <div class="col-4 mt-2">
                                            <h6 class="font-weight-bolder ctrl-size-4">
                                                UI/UX Prototype
                                            </h6>
                                            <p class="ctrl-size-2">Project Specification</p>
                                        </div>
                                        <div class="col-4 mt-2">
                                            <h6 class="font-weight-bolder ctrl-size-4">
                                                10 - 30 hrs/week
                                            </h6>
                                            <p class="ctrl-size-2">Hours needed</p>
                                        </div>
                                        <div class="col-4 mt-2">
                                            <h6 class="font-weight-bolder ctrl-size-4">
                                                3 - 6 Months
                                            </h6>
                                            <p class="ctrl-size-2">Project Timeline</p>
                                        </div>
                                        <div class="col-4 mt-2">
                                            <h6 class="font-weight-bolder ctrl-size-4">
                                                1 of 4 Hired
                                            </h6>
                                            <p class="ctrl-size-2">Developers to hire</p>
                                        </div>
                                        <div class="col-4 mt-2">
                                            <h6 class="font-weight-bolder ctrl-size-4">
                                                <font-awesome-icon
                                                    style="font-size: 14px;"
                                                    icon="map-marker-alt"
                                                    class="text-dark mr-1"
                                                ></font-awesome-icon
                                                >Lagos, Nigeria
                                            </h6>
                                            <p class="ctrl-size ml-3">Location</p>
                                        </div>
                                        <div class="col-4 mt-2">
                                            <h6 class="font-weight-bolder ctrl-size-4">
                                                Interviewing: 6
                                            </h6>
                                            <p class="ctrl-size-2">Interview</p>
                                        </div>
                                    </div>
                                    <hr />
                                    <div class="">
                                        <h5 class="text-left">Specialization</h5>
                                        <div class="text-left d-flex flex-wrap">
                                            <span
                                                class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 mt-2"
                                                v-for="skill in specialization"
                                                :key="skill"
                                            >
                                                {{ skill }}</span
                                            >
                                        </div>
                                    </div>
                                    <div class="">
                                        <h5 class="text-left">Attached Files</h5>
                                        <div class="text-left d-flex flex-wrap">
                                            <button class="btn-kovatek py-2 px-2 add-rounded">
                                                <a-icon type="upload" /> Download
                                            </button>
                                        </div>
                                    </div>
                                    <p class="ant-color text-left mt-3" @click="showLessDetails">
                                        Show Less
                                        <a-icon class="ml-2" type="double-right" rotate="-90" />
                                    </p>
                                </div>
                            </div>
                            <BidForm @bidding="getBidding" />
                            <hr class="my-4" />
                            <!-- </a-tab-pane> -->
                            <!-- <a-tab-pane tab="Job Delivered" key="2" forceRender>
                  <Delivered @openLink="openLink" />
                </a-tab-pane>
              </a-tabs> -->
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3">
                        <div class="pt-3 mt-2 pt-lg-4 mt-lg-5"></div>
                        <div class="pt-2 mt-1 ml-lg-4 mb-5" style="position:sticky;top:50px">
                            <PostedBy />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal">
                <!-- <a-button type="primary" @click="showModal">
                Open Modal with customized footer
                </a-button> -->
                <a-modal v-model="visible" title="" onOk="handleOk" width="750px">
                    <template slot="footer">
                        <a-button key="back" @click="handleCancel">Cancel</a-button>
                        <a-button
                            key="submit"
                            style="background-color:#20409a; color: #fff"
                            :loading="loading"
                            @click="showCallScheduled"
                        >
                            schedule
                        </a-button>
                    </template>
                    <div class="mt-4 p-4 bg-light"></div>
                </a-modal>
            </div>
            <div>
                <a-modal v-model="callScheduled" title="" onOk="handleOk" width="600px">
                    <template slot="footer">
                        <a-button key="submit" style="background-color:#20409a; color: #fff" @click="callScheduledOk">
                            Ok
                        </a-button>
                    </template>
                    <div class="mt-4 p-4 bg-light"></div>
                </a-modal>
            </div>

            <a-modal v-model="openLinkModal" title="" onOk="handleOk" width="600px">
                <template slot="footer">
                    <a-button key="submit" style="background-color:#20409a; color: #fff" @click="addLink" class="px-4">
                        Add
                    </a-button>
                </template>
                <div class="mt-4 p-4">
                    <h6 class="">Paste link here</h6>
                    <a-input size="large" placeholder="Paste link here" v-model="newLink" />
                </div>
            </a-modal>
        </div>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';
import PostedBy from '@/components/PostedBy.vue';
// import Delivered from '@/components/hired/Delivered.vue';
import BidForm from '@/components/projects/BidForm.vue';

export default {
    name: 'hired',
    components: {
        Navbar,
        Footers,
        PostedBy,
        // Delivered,
        BidForm,
    },
    data() {
        return {
            workHistory: [],
            skills: [],
            specialization: [],
            loading: false,
            visible: false,
            callScheduled: false,
            otherDetails: false,
            openLinkModal: false,
            newLink: '',
            showmore: true,
            bidding: {},
        };
    },
    methods: {
        getBidding(bidding) {
            console.log(bidding);
            this.bidding = {
                ...this.bidding,
                ...bidding,
            };
            console.log(this.bidding);
        },
        styleScroll: function() {
            let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
            let scrollbarDiv = document.querySelector('.scrollbar');
            if (!isChrome && !isSafari) {
                scrollbarDiv.innerHTML = 'You need Webkit browser to run this code';
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        showModal() {
            this.visible = true;
        },
        handleOk() {
            this.loading = true;
            setTimeout(() => {
                this.visible = false;
                this.loading = false;
            }, 3000);
        },
        handleCancel() {
            this.visible = false;
        },
        showCallScheduled() {
            this.loading = true;
            setTimeout(() => {
                this.visible = false;
                this.loading = false;
                this.callScheduled = true;
            }, 3000);
        },
        callScheduledOk() {
            this.callScheduled = false;
        },
        showOtherDetails() {
            this.otherDetails = !this.otherDetails;
            this.showmore = false;
        },
        showLessDetails() {
            this.otherDetails = !this.otherDetails;
            this.showmore = true;
        },
        upload({
            file,
            // fileList
        }) {
            if (file.status !== 'uploading') {
                // console.log(file, fileList);
            }
        },
        openLink() {
            this.openLinkModal = true;
        },
        addLink() {
            this.linkList.push(this.newLink);
            this.openLinkModal = false;
        },
    },
    mounted() {},
};
</script>
<style scoped>
.browse-list {
    width: 80%;
}
.sort-by {
    position: relative;
    top: 33px;
}
.icon-size {
    font-size: 25px;
}
.icon-size1 {
    font-size: 20px;
}
.img-height {
    width: 60px;
    height: 60px;
}
.img-height-2 {
    width: 130px;
    height: 130px;
}
.icon-env {
    font-size: 20px;
}
.ctrl-size {
    font-size: 10px;
}
.ctrl-size-1 {
    font-size: 20px;
}
.ctrl-size-2 {
    font-size: 11px;
}
.ctrl-size-3 {
    font-size: 9px;
}
.ctrl-size-4 {
    font-size: 13px;
}
.latest {
    color: #2db7f5;
}
.jobs-post {
    height: 400px;
    overflow-y: scroll;
}
.new-project {
    width: 260px;
}
.add-new {
    color: #20409a;
}
.add-new:hover {
    color: #0c2b80;
}
.bg-skills {
    background-color: #4bb38e;
    color: #fff;
}
.text-senior {
    color: #bd6377;
}
.text-intermediate {
    color: #bdbd50;
}
.btn-rounded {
    border-radius: 30px;
}
[data-toggle='collapse'] .fas:before {
    content: '\f055';
}

[aria-expanded='true'] .fas:before {
    content: '\f056';
}

[data-toggle='collapse'].collapsed .fas:before {
    content: '\f055';
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
    .new-project {
        width: 300px;
    }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .img-height {
        width: 60px;
        height: 60px;
    }
    .new-project {
        width: 260px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
    .hired-width {
        width: 500px;
    }
    .notifications-width {
        width: 600px;
    }
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
    .hired-width {
        width: 85%;
    }
    .notifications-width {
        width: 90%;
    }
}

@media screen and (max-width: 550px) {
    .ctrl-search {
        width: 55%;
    }
    .img-height {
        width: 65px;
        height: 65px;
    }
    .img-height-2 {
        width: 85px;
        height: 85px;
    }
    .hired-width {
        width: 95%;
    }
    .notifications-width {
        width: 98%;
    }
}
</style>
